// src/components/common/MainTabBar.tsx
import React from "react";
import { DynamicIcon, type IconName } from "lucide-react/dynamic";

interface TabItem {
  id: string;
  label: string;
  icon: IconName;
}

interface MainTabBarProps {
  tabs: TabItem[];
  activeId: string;
  onTabClick: (id: string) => void;
  className?: string;
}

const MainTabBar: React.FC<MainTabBarProps> = ({ tabs, activeId, onTabClick, className = "" }) => {
  return (
    <div className={`mb-6 border-b border-gray-700/50 ${className}`}>
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center justify-center lg:justify-start gap-6">
          {tabs.map((t) => (
            <button
              key={t.id}
              className={`px-1 py-3 -mb-px text-sm font-medium transition-colors duration-200 border-b-2 whitespace-nowrap flex-shrink-0 flex items-center gap-2 ${
                activeId === t.id
                  ? 'border-blue-500 text-white'
                  : 'border-transparent text-gray-400 hover:text-white hover:border-gray-500/60'
              }`}
              aria-current={activeId === t.id ? 'page' : undefined}
              onClick={() => onTabClick(t.id)}
            >
              <DynamicIcon name={t.icon} className="w-4 h-4" />
              {t.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainTabBar;


